import axios, { Axios } from 'axios'
import config from '../../../config'
import { store } from '../../../redux-store'
import { usersSlice } from '../../users/slices/user-slice'
import { getSessionToken } from './local-storage-service'
import { userLogout } from '../../users/utils/user-utils'

export const getApiClient = (): Axios => {
  const client = axios.create({
    baseURL: config.app.baseUrl
  })
  return client
}

export function apiBaseUrl() {
  axios.defaults.withCredentials = true
  return config.app.baseUrl
  // return process.env.REACT_APP_API_ENDPOINT
}

// const getConfig = () => {
//   return {
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   }
// }

// export const post = (url: string, body: any) => {
//   const fullUrl = apiBaseUrl() + url

//   return new Promise((resolve, reject) => {
//     axios
//       .post(fullUrl, body, getConfig())
//       .then((response) => {
//         resolve(response)
//       })
//       .catch((e) => reject(e))
//   })
// }

export const getApiClientWithAuth = (): Axios => {
  const client = axios.create({
    baseURL: config.app.baseUrl,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getSessionToken()}`
    }
  })

  client.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      if (error.response && error.response.status === 401) {
        store.dispatch(usersSlice.actions.showSessionExpiredDialog(true))
      } else if (error.response && error.response.status == 403) {
        userLogout()
      }
      return Promise.reject(error)
    }
  )

  return client
}

// function getConfigWithToken() {
//   return {
//     headers: {
//       'Content-Type': 'application/json',
//       Authorization: 'Bearer ' + getSessionToken()
//     }
//   }
// }

// export const postWithAuth = (url: string, body: any) => {
//   const fullUrl = apiBaseUrl() + url
//   return new Promise((resolve, reject) => {
//     axios
//       .post(fullUrl, body, getConfigWithToken())
//       .then((response) => {
//         resolve(response)
//       })
//       .catch((e) => reject(e))
//   })
// }
